import React, { ReactElement } from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";

import SlideButton from "./SlideButton";

interface Props {
  id: string;
  idx: number;
  value: number;
  set: boolean;
  setCriterion: (idx: number, id: string, val: number, set: boolean) => void;
}

export default function Criterion({
  id,
  idx,
  value,
  set,
  setCriterion,
}: Props): ReactElement {
  const setIsChecked = () => {
    setCriterion(idx, id, value, !set);
  };
  return (
    <TableRow>
      <TableCell>{id}</TableCell>
      <TableCell>
        <SlideButton isChecked={set} setIsChecked={setIsChecked} text="" />
      </TableCell>
      <TableCell>
        <input
          type="number"
          value={value}
          max={120}
          min={0}
          onChange={(e) => {
            setCriterion(idx, id, parseInt(e.target.value), set);
          }}
        />
      </TableCell>
    </TableRow>
  );
}
